import { intersection } from 'lodash-es';
import {
  ALL_SUPPORTED_COUNTRIES_STRING,
  SUPPORTED_COUNTRIES_ALL,
} from '../../../../../../constants/userSetting';
import { PREFERRED_COUNTRIES } from '../../../../../../utils/intlTel';

export function getMobilePhoneDefaultCountry(
  allowedCountryCodes,
  _requestCountry = '',
) {
  const preferredCountries = PREFERRED_COUNTRIES;
  const onlyCountries = allowedCountryCodes?.map((countryCode) =>
    countryCode.toLowerCase(),
  );
  const requestCountry = _requestCountry.toLowerCase();

  if (!Array.isArray(onlyCountries) || onlyCountries.includes(requestCountry)) {
    return requestCountry;
  }

  const selectedPreferredCountries = intersection(
    preferredCountries,
    onlyCountries,
  );

  if (selectedPreferredCountries.length > 0) {
    return selectedPreferredCountries[0];
  }
  return onlyCountries.reduce(
    (prev, item) => (prev.localeCompare(item) < 0 ? prev : item),
    onlyCountries[0],
  );
}

export function getMobilePhoneCountriesFromUserSettings(
  userSettings,
  merchantData = {},
) {
  const countries =
    userSettings?.sms_verification?.supported_countries ??
    SUPPORTED_COUNTRIES_ALL;
  if (countries.length === 0) {
    return [merchantData.base_country_code];
  }
  if (countries.includes(ALL_SUPPORTED_COUNTRIES_STRING)) {
    // In intl-tel-input, onlyCountries in undefined is "all countries"
    return undefined;
  }
  return countries.reduce((prev, code) => {
    if (typeof code === 'string') {
      const lowerCaseCode = code.toLowerCase();
      prev.push(lowerCaseCode);
    }
    return prev;
  }, []);
}
